import { Pipe, PipeTransform } from '@angular/core';
import { MapMarkersTypeEnum } from '@app/core/enums/map/map-markers-type.enum';
import { EqualsMapMarkerConfig, RangeMapMarkerConfig } from '@app/core/model/entities/asset/map-marker';

@Pipe({
    name: 'mapMarkerConfigLabel',
    standalone: false
})
export class MapMarkerConfigLabel implements PipeTransform {
  public transform(config: EqualsMapMarkerConfig | RangeMapMarkerConfig, type: MapMarkersTypeEnum): string {
    switch (type) {
      case (MapMarkersTypeEnum.MAP_MARKER_TYPE_EQUALS):
        return (config as EqualsMapMarkerConfig).value;
      case (MapMarkersTypeEnum.MAP_MARKER_TYPE_RANGE):
        return (config as RangeMapMarkerConfig).label;
      default:
        return '';
    }
  }
}
